window.onload = function () {

  /* show / hide main nav
  -------------------------------------------------- */
  var btnnav = document.querySelector('.js-togglemenu');
  var mobilenav = document.querySelector('.js-navwrapper');

  btnnav.onclick = function () {
    btnnav.classList.toggle('active');
    mobilenav.classList.toggle('active');
  }

};

window.onscroll = function () {
  changeHeaderMargin()
};

function changeHeaderMargin() {
  var header = document.getElementById("navigation")
  if (document.body.scrollTop > 5 || document.documentElement.scrollTop > 5) {
    header.style.padding = '0px 42px';
  } else {
    header.style.padding = '42px';
  }
}



